var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:star-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.02721 3.15475C6.7663 1.82941 7.13555 1.16675 7.68796 1.16675C8.24038 1.16675 8.60963 1.82941 9.34871 3.15475L9.54005 3.49775C9.75005 3.87458 9.85505 4.063 10.0184 4.18725C10.1817 4.3115 10.3859 4.35758 10.7942 4.44975L11.1652 4.53375C12.6002 4.85866 13.3171 5.02083 13.488 5.56975C13.6584 6.11808 13.1695 6.69033 12.1913 7.83425L11.9381 8.13C11.6605 8.45492 11.521 8.61766 11.4586 8.81833C11.3962 9.01958 11.4172 9.23658 11.4592 9.67L11.4977 10.0649C11.6453 11.5915 11.7194 12.3545 11.2725 12.6934C10.8257 13.0329 10.1537 12.7232 8.81088 12.1048L8.46263 11.945C8.08113 11.7688 7.89038 11.6813 7.68796 11.6813C7.48555 11.6813 7.2948 11.7688 6.9133 11.945L6.56563 12.1048C5.22221 12.7232 4.55021 13.0323 4.10396 12.694C3.65655 12.3545 3.73063 11.5915 3.87821 10.0649L3.91671 9.67058C3.95871 9.23658 3.97971 9.01958 3.91671 8.81892C3.85488 8.61767 3.71546 8.45492 3.4378 8.13058L3.18463 7.83425C2.20638 6.69092 1.71755 6.11867 1.88788 5.56975C2.0588 5.02083 2.7763 4.85808 4.2113 4.53375L4.5823 4.44975C4.99005 4.35758 5.19363 4.3115 5.35755 4.18725C5.52088 4.063 5.62588 3.87458 5.83588 3.49775L6.02721 3.15475Z",
    fill: "#06C778"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6aa1eeb8dd61b322768af207ee0a00fa.svg";
export { ForwardRef as ReactComponent };